import React, { useEffect, useState } from "react";
import {
  Modal,
  Table,
  Typography,
  Button,
  Space,
  Checkbox,
  message,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import "./TaskDependencyMapping.css";
import __ from "lodash";
import { invertColor } from "../../../HR/TimeClock/Util";
import swal from "sweetalert";
import { CriteriaModal } from "../../../TaskBluePrints/HelperComponents/CriteriaModal";
import { evaluateEdgeVisibility } from "../../../../Util/CommonUtil";

const { Text } = Typography;

const TaskDependencyMapping = ({
  state,
  setState,
  renameMap,
  MainData,
  DepsData,
  fromThreeDots = false,
  extraFunction,
  onCancel,
}) => {
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  const [possibleDependencyData, setPossibleDependencyData] = useState([]);
  const [dependencyCloningData, setDependencyCloningData] = useState({
    Approved: [],
    Rejected: [],
  });
  const [checkedKeys, setCheckedKeys] = useState([]);
  function getStatusInfo(data, statusId) {
    const node = data?.Nodes?.find((n) => n.id === String(statusId));
    if (!node) return null;
    return {
      label: node.data?.label || "",
      color: node.data?.color || "",
    };
  }

  function enrichDepsData(depsData, data) {
    const enrichedDeps = [];
    const taskMap = new Map();
    const subtaskMap = new Map();
    for (const pipeline of data) {
      const pipelineName = pipeline.PipelineName;
      const pipelineROWID = pipeline.PipelineROWID;
      for (const task of pipeline.Tasks) {
        if (!taskMap.has(task.TaskTemplateId)) {
          taskMap.set(task.TaskTemplateId, []);
        }
        taskMap.get(task.TaskTemplateId).push({
          templateId: task.TaskTemplateId,
          taskName: task.TaskName,
          pipelineTempId: pipeline.PipelineTemplateId,
          taskFlowObject: task.TaskFlowObject,
          taskStatus: task.TaskStatus,
          pipelineName,
          pipelineROWID,
          ROWID: task.TaskROWID,
        });
        if (Array.isArray(task.SubTasks)) {
          for (const subtask of task.SubTasks) {
            if (!subtaskMap.has(subtask.SubTaskTemplateId)) {
              subtaskMap.set(subtask.SubTaskTemplateId, []);
            }
            subtaskMap.get(subtask.SubTaskTemplateId).push({
              templateId: subtask.SubTaskTemplateId,
              pipelineTempId: pipeline.PipelineTemplateId,
              taskFlowObject: subtask.TaskFlowObject,
              taskName: subtask.TaskName,
              ROWID: subtask.SubTaskROWID,
              taskStatus: subtask.TaskStatus,
              pipelineName,
              pipelineROWID,
              TaskROWID: task.TaskROWID,
            });
          }
        }
      }
    }
    for (const dep of depsData.deps) {
      // let resolved = false;
      if (
        dep.STaskType === "Tasks" &&
        depsData.ROWIDs.includes(dep.TargetPipelineROWID)
      ) {
        const taskList = taskMap.get(dep.SourceTaskId) || [];
        for (const task of taskList) {
          let resolvedData = {
            STaskType: dep.STaskType,
            taskType: dep.TaskType,
            sourceDependencyStatus: dep.SourceDependencyStatus,
            targetDependencyStatus: dep.TargetDependencyStatus,
            dependencyType: dep.DependancyType,
            TargetPipelineROWID: dep.TargetPipelineROWID,
            TargetPipelineName: dep.TargetPipelineName,
            key: `Task${task.ROWID}${task.pipelineTempId}${task.templateId}_${dep.TaskType}${dep.TargetTaskId}${dep.TargetPipelineROWID}${dep.SourceDependencyStatus}${dep.TargetDependencyStatus}`,
            Sname: task.taskName,
            MODIFIEDBY: userInfo?.email_id,
            CREATEDBY: userInfo?.email_id,
            ActualTaskROWID: task.ROWID,
            STemplateID: dep.SourceTaskId,
            TTemplateID: dep.TargetTaskId,
            Tname: dep.TargetTaskName,
            taskStatus: getStatusInfo(task.taskFlowObject, task.taskStatus),
            pipelineName: task.pipelineName,
            pipelineROWID: task.pipelineROWID,
          };
          // resolved = true;
          enrichedDeps.push({ ...resolvedData });
        }
      } else if (
        dep.STaskType === "SubTasks" &&
        depsData.ROWIDs.includes(dep.TargetPipelineROWID)
      ) {
        const subTaskList = subtaskMap.get(dep.SourceTaskId) || [];
        for (const subtask of subTaskList) {
          let resolvedData = {
            STaskType: dep.STaskType,
            taskType: dep.TaskType,
            sourceDependencyStatus: dep.SourceDependencyStatus,
            targetDependencyStatus: dep.TargetDependencyStatus,
            dependencyType: dep.DependancyType,
            TargetPipelineROWID: dep.TargetPipelineROWID,
            TargetPipelineName: dep.TargetPipelineName,
            key: `SubTask${subtask.ROWID}${subtask.pipelineTempId}${subtask.templateId}_${dep.TaskType}${dep.TargetTaskId}${dep.TargetPipelineROWID}${dep.SourceDependencyStatus}${dep.TargetDependencyStatus}`,
            Sname: subtask.taskName,
            MODIFIEDBY: userInfo?.email_id,
            CREATEDBY: userInfo?.email_id,
            STemplateID: dep.SourceTaskId,
            TTemplateID: dep.TargetTaskId,
            ActualTaskROWID: subtask.ROWID,
            Tname: dep.TargetTaskName,
            taskStatus: getStatusInfo(
              subtask.taskFlowObject,
              subtask.taskStatus
            ),
            pipelineName: subtask.pipelineName,
            pipelineROWID: subtask.pipelineROWID,
          };
          // resolved = true;
          enrichedDeps.push({ ...resolvedData });
        }
      }
      // if (!resolved) {
      //   continue;
      // }
      // enrichedDeps.push(resolvedData);
    }
    return enrichedDeps;
  }
  function confirmAndCancel() {
    if (fromThreeDots) {
      swal({
        title: "Are you sure?",
        text: "If you cancel changes will be lost!",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setPossibleDependencyData([]);
          resetData();
          onCancel();
        }
      });
    }
  }
  function resetData() {
    setCheckedKeys([]);
    setDependencyCloningData({ Approved: [], Rejected: [] });
    localStorage.setItem(
      "dependencyCloningData",
      JSON.stringify({ Approved: [], Rejected: [] })
    );
  }
  useEffect(() => {
    if (state && DepsData.deps.length > 0) {
      let res = enrichDepsData(DepsData, MainData);
      console.log("res", res);
      setPossibleDependencyData(res);
      resetData();
    } else if (state && DepsData.deps.length == 0) {
      resetData();
      setPossibleDependencyData([]);
    }
  }, [state, DepsData.deps]);
  const handleContinue = () => {
    if (
      possibleDependencyData.length !=
      dependencyCloningData.Approved.length +
        dependencyCloningData.Rejected.length
    ) {
      message.warning("Please answer all Dependencies first!!!");
      return;
    }
    if (fromThreeDots) {
      swal({
        title: "Are you sure you want to save the changes?",
        text: "",
        icon: "warning",
        buttons: ["Cancel", "Save"],
        dangerMode: true,
      }).then(async function (isConfirm) {
        if (isConfirm) {
          extraFunction(dependencyCloningData);
          setDependencyCloningData({ Approved: [], Rejected: [] });
          setState(false);
        }
      });
    } else {
      localStorage.setItem(
        "dependencyCloningData",
        JSON.stringify(dependencyCloningData)
      );
      setDependencyCloningData({ Approved: [], Rejected: [] });
      setState(false);
    }
  };
  const handleAcceptSelected = () => {
    let dependencyData = [...possibleDependencyData];
    let data = { ...dependencyCloningData };
    let keys = [...checkedKeys];
    for (let index = 0; index < filteredData.length; index++) {
      const record = filteredData[index];
      if (
        keys.includes(record.key) &&
        !data.Approved.some((obj) => Object.keys(obj).includes(record.key))
      ) {
        data.Rejected = data.Rejected.filter(
          (obj) => !Object.keys(obj).includes(record.key)
        );
        data.Approved = [...data.Approved, { [record.key]: record }];
      }
    }
    setDependencyCloningData(data);
  };

  const handleRejectSelected = () => {
    let dependencyData = [...possibleDependencyData];
    let data = { ...dependencyCloningData };
    let keys = [...checkedKeys];
    for (let index = 0; index < filteredData.length; index++) {
      const record = filteredData[index];
      if (
        keys.includes(record.key) &&
        !data.Rejected.some((obj) => Object.keys(obj).includes(record.key))
      ) {
        data.Approved = data.Approved.filter(
          (obj) => !Object.keys(obj).includes(record.key)
        );
        data.Rejected = [...data.Rejected, { [record.key]: record }];
      }
    }
    setDependencyCloningData(data);
  };
  const handleAccept = (record) => {
    let data = { ...dependencyCloningData };
    if (!data.Approved.some((obj) => Object.keys(obj).includes(record.key))) {
      data.Rejected = data.Rejected.filter(
        (obj) => !Object.keys(obj).includes(record.key)
      );
      data.Approved = [...data.Approved, { [record.key]: record }];
      setDependencyCloningData(data);
    }
  };

  const handleReject = (record) => {
    let data = { ...dependencyCloningData };
    if (!data.Rejected.some((obj) => Object.keys(obj).includes(record.key))) {
      data.Approved = data.Approved.filter(
        (obj) => !Object.keys(obj).includes(record.key)
      );
      data.Rejected = [...data.Rejected, { [record.key]: record }];
      setDependencyCloningData(data);
    }
  };
  function selectDeselectAll(checked) {
    if (checked) {
      let keys = __.cloneDeep(possibleDependencyData);
      setCheckedKeys(keys.map((item) => item.key));
    } else {
      setCheckedKeys([]);
    }
  }
  function onRowCheckChange(key, checked) {
    if (checked) {
      setCheckedKeys((prev) => [...prev, key]);
    } else {
      setCheckedKeys((prev) => prev.filter((k) => k != key));
    }
  }
  function colorNameToHex(color) {
    const ctx = document.createElement("canvas").getContext("2d");
    ctx.fillStyle = color;
    return ctx.fillStyle;
  }
  const getStyleObj = (temp) => {
    let sty = {
      backgroundColor: "white",
      color: "black",
      border: "1px solid white",
      paddingRight: "0.5em",
    };
    if (temp && temp.color) {
      sty["backgroundColor"] = temp.color;
      sty["border"] = `1px solid ${temp.color}`;
      let color =
        temp.color[0] == "#" ? temp.color : colorNameToHex(temp.color);
      sty["color"] = invertColor(color, true);
    }
    return sty;
  };
  const columns = [
    {
      title: (
        <Checkbox
          checked={
            possibleDependencyData.length == checkedKeys.length &&
            possibleDependencyData.length != 0
          }
          onClick={(e) => selectDeselectAll(e.target.checked)}
          indeterminate={false}
        />
      ),
      dataIndex: "checkbox",
      key: "checkbox",
      render: (_, record) => (
        <Checkbox
          checked={checkedKeys.includes(record.key)}
          onChange={(e) => onRowCheckChange(record.key, e.target.checked)}
        />
      ),
    },
    {
      title: "Existing Task Name",
      dataIndex: "Sname",
      key: "Sname",
    },
    {
      title: "Task Type",
      dataIndex: "STaskType",
      key: "STaskType",
      render: (_, record) => (record.STaskType == "Tasks" ? "Task" : "Subtask"),
    },
    {
      title: "Task Status",
      dataIndex: "taskStatus",
      key: "taskStatus",
      render: (_, record) => (
        <p
          style={getStyleObj(record.taskStatus)}
          className="Task-Status-P Elipsis-Class"
          title={`${record.taskStatus.label}`}
        >
          {record.taskStatus.label}
        </p>
      ),
    },
    {
      title: "Pipeline",
      dataIndex: "pipelineName",
      key: "pipelineName",
    },
    {
      title: "Dependency",
      dataIndex: "sourceDependencyStatus",
      key: "sourceDependencyStatus",
      render: (_, record) =>
        `${record.sourceDependencyStatus}${record.targetDependencyStatus}`,
    },
    {
      title: "Dependency Type",
      dataIndex: "dependencyType",
      key: "dependencyType",
    },
    {
      title: "New Task Name",
      dataIndex: "Tname",
      key: "Tname",
    },
    {
      title: "New Task Pipeline",
      dataIndex: "TargetPipelineName",
      key: "PipeTargetPipelineName",
      render: (_, record) =>
        fromThreeDots
          ? renameMap[record.TargetPipelineROWID]?.templatePipelineName ||
            record.TargetPipelineName
          : record.TargetPipelineName,
    },
    {
      title: "New Task Type",
      dataIndex: "taskType",
      key: "taskType",
      render: (_, record) => (record.taskType == "Tasks" ? "Task" : "Subtask"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<CheckOutlined style={{ color: "green" }} />}
            style={
              dependencyCloningData.Approved.some((obj) =>
                Object.keys(obj).includes(record.key)
              )
                ? { background: "#f0f0f0", border: "1px solid lightgreen" }
                : {}
            }
            onClick={() => handleAccept(record)}
          />
          <Button
            type="text"
            icon={<CloseOutlined style={{ color: "red" }} />}
            style={
              dependencyCloningData.Rejected.some((obj) =>
                Object.keys(obj).includes(record.key)
              )
                ? { background: "#f0f0f0", border: "1px solid lightsalmon" }
                : {}
            }
            onClick={() => handleReject(record)}
          />
        </Space>
      ),
    },
  ];
  //new changes for filter
  const [criteriaModal, setCriteriaModal] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [filteredData, setFilteredData] = useState(possibleDependencyData);
  const [view, setView] = useState("view");
  const criteriaFieldGroupsArray = {
    Dependancy_Table_Fields: [
      {
        ROWID: 1,
        label: "Existing Task Name",
        field: "Sname",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 2,
        label: "Task Type",
        field: "STaskType",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 3,
        label: "Task Status",
        field: "taskStatus",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 4,
        label: "Pipeline",
        field: "pipelineName",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 5,
        label: "Dependency",
        field: "sourceDependencyStatus",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 6,
        label: "Dependency Type",
        field: "dependencyType",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 7,
        label: "New Task Name",
        field: "Tname",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 8,
        label: "New Task Pipeline",
        field: "TargetPipelineName",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
      {
        ROWID: 9,
        label: "New Task Type",
        field: "taskType",
        type: "TEXT",
        module: "Dependency_Module",
        apikey: "",
      },
    ],
  };
  let ModifiedpossibleDependencyData = possibleDependencyData.map((item) => {
    let modifiedItem = {
      ...item,
      taskStatus: item.taskStatus.label,
      sourceDependencyStatus: `${item.sourceDependencyStatus}${item.targetDependencyStatus}`,
      TargetPipelineName: fromThreeDots
        ? renameMap[item.TargetPipelineROWID]?.templatePipelineName ||
          item.TargetPipelineName
        : item.TargetPipelineName,
    };
    return modifiedItem;
  });

  const onSelectedData = (data) => {
    setSelectedData(data);
    setCriteriaModal(false); 
    const filteredDependencies = ModifiedpossibleDependencyData.filter((item) =>
      evaluateEdgeVisibility({ Dependancy_Table_Fields: item }, { Criteria: data })
    ); 
    setFilteredData( filteredDependencies.map((item) => ({ ...item,  taskStatus: { label: item.taskStatus }, })) ); 
  };

  console.log("FilteredData", dependencyCloningData);

  useEffect(() => {
    if (selectedData.length == 0 && possibleDependencyData.length > 0) {
      setFilteredData(possibleDependencyData);
    }
    if (selectedData.length == 0) {
      setFilteredData(possibleDependencyData);
    }
  }, [possibleDependencyData, selectedData]);
  //End

  const titleNode = (
    <Space>
      Dependency Selection
      <Button
        icon={<FilterOutlined />}
        type={selectedData.length ? "primary" : "default"}
        size="small"
        onClick={() => setCriteriaModal(true)}
        style={{ position: "relative" }}
      >
        {selectedData.length > 0 && (
          <CloseOutlined
            className="closedIcondelete"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedData([]);
            }}
            style={{
              position: "absolute",
              top: -4,
              right: -4,
              fontSize: 12,
              cursor: "pointer",
              color: "red",
            }}
          />
        )}
      </Button>
    </Space>
  );
  return (
    <>
      <Modal
        title={titleNode}
        open={state}
        rootClassName="possibleDependenciesModal"
        footer={null}
        onCancel={confirmAndCancel}
        maskClosable={false}
      >
        <CriteriaModal
          mainFields={criteriaFieldGroupsArray}
          open={criteriaModal}
          criteriaRows={selectedData}
          action={view}
          setOpen={setCriteriaModal}
          onSave={(data) => {
            onSelectedData(data);
          }}
          FromTask={false}
          DependacyFilter={true}
          DependancyModuleData={ModifiedpossibleDependencyData}
        />
        <Table
          dataSource={filteredData}
          columns={columns}
          rowKey={(record, index) => index}
          // rowClassName={(record) => { return record.taskType === "Task" ? "highlight-green" : ""; }}
          pagination={false}
        />
        <Space
          style={{ marginTop: 16, display: "flex", justifyContent: "end" }}
        >
          <Button
            type="primary"
            disabled={checkedKeys.length === 0}
            onClick={handleAcceptSelected}
          >
            Accept Selected
          </Button>

          <Button
            danger
            disabled={checkedKeys.length === 0}
            onClick={handleRejectSelected}
          >
            Reject Selected
          </Button>
          <Button
            type="primary"
            disabled={
              possibleDependencyData.length !=
              dependencyCloningData.Approved.length +
                dependencyCloningData.Rejected.length
            }
            onClick={handleContinue}
          >
            Continue
          </Button>
        </Space>
      </Modal>
    </>
  );
};

export default TaskDependencyMapping;
